import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import phonakimg from "../../../img/Phonak-logo.png";
import "../Products/Products.css";
import ReactPlayer from "react-player";
import saveimg from "../../../img/save1.png";
import save2img from "../../../img/save2.png";
import save3img from "../../../img/save3.png";
import save4img from "../../../img/save4.png";
import save5img from "../../../img/Phonak-Naida-Paradise.jpg";
import save6img from "../../../img/save6.png";
import sildeimg1 from "../../../img/silde1.png";
import sildeimg2 from "../../../img/silde2.png";
import sildeimg3 from "../../../img/silde3.jpg";
import sildeimg4 from "../../../img/silde4.png";
import sildeimg5 from "../../../img/silde5.png";
import sildeimg6 from "../../../img/silde6.png";
import sildeimg7 from "../../../img/silde7.png";
import sildeimg9 from "../../../img/silde9.png";
import sildeimg10 from "../../../img/silde11.png";
import sildeimg11 from "../../../img/silde13.png";
import sildeimg12 from "../../../img/silde12.png";
import tast1 from "../../../img/test1.jpg";
import tast2 from "../../../img/test2.jpg";
import tast3 from "../../../img/test3.jpg";
import tast4 from "../../../img/test4.jpg";
import mini1 from "../../../img/mini1.png";
import mini2 from "../../../img/mini2.png";
import mini3 from "../../../img/mini3.png";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function PhonakHearing() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: false, // Hide the previous arrow
    nextArrow: false, // Hide the next arrow
  };

  var Products = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
     
      {
        breakpoint: 767, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
       <Helmet>
      <title>Phonak Hearing Aid Singapore</title>
        <meta name="description" content="Need a trustworthy hearing aid? Opt for Phonak for premium quality and cutting-edge tech. Visit The Hearing Centre for a hearing test now!" />
        <meta property="og:title" content="Phonak Hearing Aid Singapore"></meta>
        <meta property="og:description" content="Need a trustworthy hearing aid? Opt for Phonak for premium quality and cutting-edge tech. Visit The Hearing Centre for a hearing test now!"></meta>
    </Helmet>
      <Header />
      <section className="phonak_hearing">
        <div className="container">
          <h1 className="Heading_text">Phonak</h1>
          <p className="Heading_pergrap">
            Phonak was conceived and conceptualized in 1947 in Switzerland. Ever
            since its commencement, it has strive to achieve a single objective
            of improving the lives of people with hearing disabilities.
          </p>
        </div>
      </section>

      <section className="HearingSolutions">
        <div className="container">
          <div className="row">
            <div className="img_solution">
              <img src={phonakimg} alt="" className="img-fluid" />

              <h1>
                Phonak: Bringing The Unparalleled Hearing Solutions To People's
                Lives
              </h1>
              <h5>One Of The Most Sought-After Sonova Brands.</h5>
              <p>
                The use of quality-engrained materials and precision in these
                Phonak hearing aids do everything to meet the needs of people
                who have a hearing impairment.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center ">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <ReactPlayer
                  height="500px"
                  url="https://www.youtube.com/embed/QaCFJ4o0PJE?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                  className="video_div"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aids: <br />
                  The History Behind
                </h5>
                <p>
                  Phonak was conceived and conceptualized in 1947 in
                  Switzerland. Ever since its commencement, it has strive to
                  achieve a single objective of improving the lives of people
                  with hearing disabilities. Phonak aims to passionately create
                  a world where people from all walks of life are able to freely
                  enjoy these sounds of Mother Earth with the use of their
                  hearing aids. In its relentless pursuit of excellence, the
                  venture has managed to launch many different sorts of Phonak
                  hearing aids that comes with various functions, features and
                  styles, capable of combating various problems faced by people
                  with hearing disabilities. With its extensive range of digital
                  hearing aids, alongside with the various Phonak hearing aid
                  accessories and wireless communication systems, listening to
                  the things you love and conversing with your loved ones to the
                  fullest becomes easier. This brings Phonak hearing aid a step
                  closer to its goal of creating a conducive world where
                  everyone has the rights to live their own lives to the fullest
                  potential.
                </p>
                <p>
                  Indeed, it is the brand’s innovative outlook and great vision
                  which has helped it to bring a revolutionary change in the
                  hearing aids industry. Want to see the collection? Let’s dive
                  in!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Phonak Hearing Aid: Lumity</h1>
          <h5>
            The Latest Hearing Aid, Phonak Audeo Lumity: Made For Easier Hearing
          </h5>
          <p>
            Audéo Lumity focuses on giving you improved speech understanding
            with its unique Phonak SmartSpeech™ Technology so you can enjoy
            conversations in many challenging listening situations. Lumity has
            been trained with artificial intelligence-based machine learning to
            accurately identify a sound environment. It perfectly orchestrates
            the numerous comfort and speech-understanding features in Lumity to
            adapt to your personal environment. Enjoy the benefits that this
            technology brings to you and your loved ones. Phonak Audéo Life™
            Lumity is the second generation of the world’s first waterproof
            rechargeable hearing aid. Ideal hearing solution for anyone who has
            an active lifestyle and puts their hearing aids to the test.
          </p>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={saveimg} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aid: <br />
                  Phonak Audeo Lumity
                </h5>
                <p>
                  The Phonak Audeo Lumity is a premium hearing aid that offers
                  advanced features and exceptional sound quality. This device
                  is designed to provide crystal-clear sound, even in
                  challenging listening environments, thanks to its
                  state-of-the-art technology. With AutoSense OS 4.0, the Audeo
                  Lumity can automatically adjust to your surroundings, ensuring
                  that you hear every word clearly, whether you’re in a noisy
                  restaurant or a quiet park. Additionally, this device is
                  incredibly comfortable to wear, with an ergonomic design that
                  fits snugly in your ear. It’s so comfortable, in fact, that
                  you’ll forget you’re even wearing it. The Audeo Lumity is also
                  eco-friendly, with a rechargeable battery that eliminates the
                  need for disposable batteries. If you’re looking for a hearing
                  aid that delivers exceptional sound quality and unmatched
                  comfort, the Phonak Audeo Lumity is an excellent choice.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="Audeo_section">
        <div className="container">
          <h1 className="Heading_text">
            Audeo <hr />
          </h1>

          <div className="row">
            <div className="col-md-4">
              <div class="card">
                <img src={save2img} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Audeo L-R</h5>
                  <p class="card-text">Mild to profound hearing loss</p>
                  <p class="card-text">Health data tracking**</p>
                  <p class="card-text">Tap Control</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={save3img} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Audeo L-RT</h5>
                  <p class="card-text">Mild to profound hearing loss</p>
                  <p class="card-text">Health data tracking**</p>
                  <p class="card-text">Telecoil</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={save4img} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Audeo L-RL</h5>
                  <p class="card-text">Mild to profound hearing loss</p>
                  <p class="card-text">Health data tracking**</p>
                  <p class="card-text">Tap Control</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Phonak Hearing Aid: Paradise Series</h1>
          <h5>
            The Latest Collection, To Offer You Phonak Hearing Aids Of
            Unsurpassed Quality
          </h5>
          <p>
            To provide an unrivaled hearing experience to their users, these
            latest series of Phonak Paradise hearing aids comprise of the latest
            next-gen technology. It channels crisp natural sounds for users to
            fully experience the enjoyment of clear and powerful hearing. With
            the incorporation of a speech enhancer, soft-leveled conversations
            are enhanced and hence, these Phonak hearing aids provides brilliant
            speech understanding. In addition, its dynamic noise cancellation
            feature in these Phonak hearing aids, alongside the smart use of
            MyPhonak App, allow users to personalize noise cancellation in
            different noise environments for easy adaptation. These advanced and
            digital hearing aids also have built-in motion sensor and microphone
            that helps simplify the answering of phone calls, listening to music
            and activation of voice assistance, all with a simple tap. Direct
            Bluetooth connectivity to iOS and Android smartphones, TV and other
            electronic devices enable high quality streaming of audio directly
            to Phonak hearing aids. These Phonak Paradise hearing aids are also
            the first and only hearing aids in the market that supports multiple
            Bluetooth connections with your smart devices, providing you with a
            seamless streaming experience. Empowering smart apps are also
            available to enable personalization of these Phonak hearing aids to
            suit one’s needs better. Moreover, these marvelous Phonak hearing
            aids are also rechargeable, enabling users to use their Phonak
            digital hearing aids anywhere and anytime.
          </p>
        </div>
      </section>

      <section className="Paradise_Hearing_Aids">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="card_hearing">
                <h5>Phonak Audio Paradise Hearing Aids</h5>
                <div className="silder">
                  <Slider {...settings}>
                    <div>
                      <div class="card">
                        <img src={save3img} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">
                            Phonak Audio Paradise: Based on Next-Gen Technology{" "}
                          </h6>
                          <p class="card-text">
                            Battery: Built-In Rechargeable Lithium-Ion
                          </p>
                          <p class="card-text">
                            Best For People With Mild To Profound Hearing Loss
                          </p>
                          <p class="card-text">
                            Universal Bluetooth Connectivity To iOS & Android
                            Devices
                          </p>
                          <p class="card-text">
                            Binaural Voice Streaming Technology (BVST)
                          </p>
                          <p class="card-text">AutoSense OS 4.0</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="card">
                        <img src={save4img} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">
                            Audeo P-R Receiver-In-Canal{" "}
                          </h6>
                          <p class="card-text">
                            Battery: Built-In Rechargeable Lithium-Ion
                          </p>
                          <p class="card-text">
                            Best For People With Mild To Profound Hearing Loss
                          </p>
                          <p class="card-text">
                            Direct Bluetooth Connectivity To iOS & Android
                            Devices
                          </p>
                          <p class="card-text">Tap Control</p>
                          <p class="card-text">Motion Sensor Hearing</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="card">
                        <img src={save4img} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">
                            Audeo P-RT Receiver-In-Canal{" "}
                          </h6>
                          <p class="card-text">
                            Battery: Built-In Rechargeable Lithium-Ion
                          </p>
                          <p class="card-text">
                            Best For People With Mild To Profound Hearing Loss
                          </p>
                          <p class="card-text">
                            Direct Bluetooth Connectivity To iOS & Android
                            Devices
                          </p>
                          <p class="card-text">Tap Control</p>
                          <p class="card-text">Motion Sensor Hearing</p>
                          <p class="card-text">Telecoil</p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="card">
                        <img src={save2img} class="card-img-top" alt="..." />
                        <div class="card-body">
                          <h6 class="card-title">
                            Audeo P-312 Receiver-In-Canal{" "}
                          </h6>
                          <p class="card-text">Battery: 312 Zinc Air</p>
                          <p class="card-text">
                            Best For People With Mild To Profound Hearing Loss
                          </p>
                          <p class="card-text">
                            Direct Bluetooth Connectivity To iOS & Android
                            Devices
                          </p>
                        </div>
                      </div>
                    </div>
                  </Slider>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card_hearing">
                <h5>Phonak Audeo Paradise Hearing Aids</h5>
                <div className="silder">
                  <div class="card">
                    <img src={save3img} class="card-img-top" alt="..." />
                    <div class="card-body">
                      <h6 class="card-title">
                        Phonak Naida Paradise Hearing Aid{" "}
                      </h6>
                      <p class="card-text">
                        Battery: Built-In Rechargeable Lithium-Ion or 675 Zinc
                        Aid
                      </p>
                      <p class="card-text">
                        Best For People With Sever To Profound Hearing Loss
                      </p>
                      <p class="card-text">
                        Direct Bluetooth Connectivity To iOS & Android Devices
                      </p>
                      {/* <p class="card-text">Dynamic Noise Cancellation</p> */}
                      <p class="card-text">Motion Sensor Hearing</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="KeyFeatures">
        <div className="container">
          <h1 className="Heading_text">
            Phonak Paradise Hearing Aids: Key Features
          </h1>
          <div className="silder_div">
            <Slider {...Products}>
              <div>
                <div class="card">
                  <img src={sildeimg1} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">ActiveVent Receiver </h6>
                    <p class="card-text">
                      World’s first intelligent hearing aid speaker, controlled
                      by AutoSense OS 4.0 that automatically adjust your hearing
                      aids to suit the environment, designed for challenging
                      listening environments or for moments of focus
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={sildeimg2} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Tap Control </h6>
                    <p class="card-text">
                      Answer phone calls, stream or pause music and activate
                      voice assistants just by tapping your hearing aids. Motion
                      sensor in Phonak hearing aid makes this process effortless
                      and seamless. Built-in microphone also allows for
                      hands-free call and voice assistant activation.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg3} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">
                      Connects to Smartphone, TV And More{" "}
                    </h6>
                    <p class="card-text">
                      Allows for direct connection to iOS, Android or
                      Bluetooth-enabled devices which allows for streaming audio
                      in excellent quality directly to your hearing aids. One
                      can also simultaneously connect two Bluetooth devices and
                      seamlessly alternate between the two devices
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg4} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Empowering Smart Apps </h6>
                    <p class="card-text">
                      Connection to the myPhonak App allows users to control
                      their Phonak hearing aids, accessing useful features and
                      personalizing their settings for the best hearing
                      experience
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={sildeimg5} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Crisp, Natural Sound </h6>
                    <p class="card-text">
                      Delivering crisp, natural sound for you to enjoy the
                      wonders of the world as they should be heard
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg6} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Brilliant Speech Understanding </h6>
                    <p class="card-text">
                      The use of Speech Enhancer boosts soft-level speech so
                      that one can enjoy conversations with friends, colleagues
                      and loved ones
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg7} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Personalized Noise Cancellation </h6>
                    <p class="card-text">
                      Dynamic Noise Cancellation feature allows you to
                      personalize the amount of noise cancellation you want all
                      in real time through the myPhonak app
                    </p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={save6img} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aid: <br />
                  Phonak Audeo Marvel
                </h5>
                <p>
                  A first-class multi-functional Receiver-In-Canal (RIC) Phonak
                  hearing aid that is combined with modern technology to provide
                  an enhanced hearing and speech experience. These Phonak Audeo
                  Marvel hearing aids provides maximum hearing efficiency of
                  clear, rich sound with minimum listening effort required.
                  Direct Bluetooth connection to iOS & Android smartphones, TV
                  and other electronic devices enables high quality streaming of
                  audio directly to Phonak hearing aids, allowing users to enjoy
                  a seamless streaming experience. These small and handy Phonak
                  hearing aids comes with rechargeable option with built-in
                  lithium-ion rechargeable batteries, allowing users to use
                  their Phonak hearing aids anywhere and anytime. Even though it
                  is small in size, these marvelous Phonak Audeo hearing aids
                  can fit a wide range of users who has mild to severe hearing
                  loss.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aid: <br />
                  Phonak Naida Marvel 
                </h5>
                <p>
                  A powerful Behind-The-Ear (BTE) Phonak hearing aid that
                  provides powerful and rich sounds, hands-free calls, Bluetooth
                  streaming, as well as maximum reliability with water and dust
                  resistance. It provides maximum hearing efficiency of clear,
                  rich sound with minimum listening effort. Direct Bluetooth
                  connection to iOS and android smartphones, TV and other
                  electronic devices is also available which allows for high
                  quality streaming of audio directly to Phonak hearing aids.
                  Moreover, these Phonak hearing aids are equipped with
                  IP68-rated water and dust resistance, making it one of the
                  most reliable and trusted power hearing aids. These powerful
                  hearing aids can fit individuals who have moderate to profound
                  hearing loss.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg9} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Phonak Hearing Aid: Marvel Series</h1>
          <h5>The Best Hearing Experience With Clear, Rich Sounds</h5>
          <p>
            Phonak provides a variety of multi-functional hearing aids that are
            committed to improving hearing without limitations. With the
            integration of their modern technology, these Phonak Marvel hearing
            aids offer brilliant speech understanding and sound quality.
          </p>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg10} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aid: <br />
                  Phonak Virto Marvel
                </h5>
                <p>
                  A customizable and wireless In-The-Canal (ITC) Phonak hearing
                  aid that provides a perfect and discreet fit with high wearing
                  comfort, direct Bluetooth connectivity and hands-free calls.
                  It provides maximum hearing efficiency of clear, rich sound
                  with minimum listening effort. Direct Bluetooth connectivity
                  to smartphones, TV and other electronic devices enables high
                  quality streaming of audio directly to Phonak hearing aids.
                  With over 1600 data points considered for Biometric
                  Calibration, these Phonak hearing aids are customized to
                  provide the perfect fit and ultimate comfort for its users.
                  Moreover, there are many trendy and stylish colours available
                  to customize these Phonak hearing aids depending on the
                  wearer’s likes. These hearing aids are suitable for
                  individuals with mild to severe hearing loss.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aid: <br />
                  Phonak Virto M Titanium
                </h5>
                <p>
                  The latest generation of super discreet customizable
                  In-The-Canal (ITC) Phonak hearing aid made from titanium that
                  provides excellent sound quality and automatic adaptation to
                  every sound environment upon first wear. This hearing aid
                  automatically adapts to every sound environments to deliver
                  exceptional hearing experiences. Being the smallest Phonak
                  hearing aid to be invented, this super discreet hearing aid
                  hides its presence such that nobody can notice it. Moreover,
                  since it is custom-made from Titanium, which is incredibly
                  strong, light-weight and durable, it can fit into anyone’s
                  ears perfectly with maximum comfort. These discreet Phonak
                  hearing aids are suitable for individuals who have mild to
                  moderate hearing loss.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg11} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Phonak Hearing Aid: Sky Marvel (Pediatric)</h1>
          <h5>The Only Pediatric Hearing Aids In The Market</h5>
          <p>
            Phonak offers a portfolio of products that enable children to
            communicate more effectively and facilitate the building of strong
            friendship bonds that are essential for developing social and
            communication skills.
          </p>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  Phonak Hearing Aid: <br />
                  Phonak Sky Marvel
                </h5>
                <p>
                  A child-friendly Behind-The-Ear (BTE) Phonak hearing aid that
                  combines the world’s first technological innovations to
                  facilitate growth and development of children. It provides
                  maximum hearing efficiency of clear, rich sound with minimum
                  listening effort. Direct Bluetooth connectivity to
                  smartphones, TV and other electronic devices enables high
                  quality streaming of audio directly to Phonak hearing aids.
                  Being rechargeable, it enables anyone to use their Phonak
                  digital hearing aids anywhere and anytime. These Phonak Sky
                  Marvel hearing aids can be fully charged in 3 hours and can be
                  used for one full day of hearing after a full charge with 10
                  hours of Roger streaming Moreover, the tamper-proof
                  child-specific design provides maximum comfort, safety and
                  robustness to support the active lifestyles that children will
                  undergo during their growth. These Phonak hearing aids can fit
                  a large group of users and are suitable for children who have
                  mild to profound hearing loss.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg12} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>Phonak Hearing Aid: Roger Accessories</h1>
          <p>
            The collection of Phonak RogerDirect hearing aid accessories
            enhances the functionality of Phonak hearing aids when paired
            together. This collection allows the Roger microphones to connect
            and stream directly to Phonak hearing aids through direct Bluetooth
            connection, without the need of an external receiver which delivers
            unsurpassed convenience and efficiency. This boost an individual’s
            understanding of hearing and speech in noise and over distance,
            enhancing adaptation to any noise environment
          </p>
        </div>
      </section>

      <section className="KeyFeatures RogerAccessories">
        <div className="container">
          <h1 className="Heading_text">
            Phonak Hearing Aid: Roger Accessories
          </h1>
          <div className="silder_div">
            <Slider {...Products}>
              <div>
                <div class="card">
                  <img src={tast1} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Roger Table Mic II </h6>
                    <p class="card-text">
                      Dedicated for working adults who participate in various
                      meetings. The innovative MultiBeam technology analyzes the
                      speech in 360°, automatically selecting the direction with
                      the best clarity. This provide up to 61% better speech
                      understanding in loud noises. Several Table Mic II can
                      also be connected and work together so that you can
                      participate and not miss out on a thing during a large
                      meeting setting. Can also transmit the sound of a
                      multimedia – e.g computer. This Phonak Roger accessory is
                      fully automatic, easy to use, and has a battery life of 16
                      hours, capable of lasting a full working day with a single
                      charge.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={tast2} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Roger Select </h6>
                    <p class="card-text">
                      Phonak’s microphone that is specifically designed to help
                      boost your hearing performance in a setting where multiple
                      conversations are taking place. The Phonak Roger Select
                      can be placed in the centre of the table, and
                      automatically selects the person who is talking and
                      seamlessly switches from one talker to another. It has
                      multiple microphones in six directions, covering speech in
                      360°. This Roger hearing accessory can also select the
                      person or conversation to focus on with a single manual
                      touch when multiple conversation is taking place.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={tast3} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Roger Touchscreen Mic </h6>
                    <p class="card-text">
                      Phonak’s simple and intuitive microphone to facilitate
                      teaching of students. It automatically switches from an
                      individual talker to a small group interaction mode,
                      depending on its placement. This device can be worn around
                      the teacher’s neck or place on a table to pick up speech
                      from a group of students. It also has intuitive indicator
                      lights and user-friendly interface and is compatible with
                      about every hearing aid. The use of this Phonak Roger
                      Touchscreen Mic allow students to participate fully and
                      actively in the classroom, hearing their teachers and
                      peers with clarity and confidence.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={tast4} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Empowering Smart Apps </h6>
                    <p class="card-text">
                      Connection to the myPhonak App allows users to control
                      their Phonak hearing aids, accessing useful features and
                      personalizing their settings for the best hearing
                      experience
                    </p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="Audeo_section ChargingOptions">
        <div className="container">
          <h1 className="Heading_text">
            Phonak Hearing Aid: Charging Options
            <hr />
          </h1>

          <div className="row">
            <div className="col-md-4">
              <div class="card">
                <img src={mini1} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Phonak Charger Case Combi </h5>
                  <p class="card-text">
                    Charger and protective hard case all in one
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={mini2} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Phonak Powerpack </h5>
                  <p class="card-text">
                    Charge your hearing aids while on the go
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={mini3} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">Phonak Mini Charger Case </h5>
                  <p class="card-text">
                    Compact charger with standard USB-C charging outlet for two
                    hearing aids
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
